import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useReveal } from '../../hooks/useReveal';

const About = () => {
  const { t } = useLanguage();
  const [ref, visible] = useReveal();

  return (
    <section id="about" ref={ref} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className={`max-w-3xl mx-auto text-center transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0A1628]">{t('about.title')}</h2>
          <div className="w-16 h-1 bg-[#00B4D8] mx-auto mt-6 rounded-full" />
          <p className="mt-8 text-base text-slate-600 leading-relaxed">{t('about.p1')}</p>
          <p className="mt-4 text-base text-slate-500 leading-relaxed">{t('about.p2')}</p>
        </div>
      </div>
    </section>
  );
};

export default About;
